import * as React from 'react';
/**
 *
 * Original name: puzzle piece
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1025
 *
 */
export const PuzzlePieceLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M17.5 10.5H17V7h-3.5v-.5c0-1.612-.889-2.5-2.5-2.5s-2.495.888-2.495 2.5V7H5v12h5l.002-2c0-.791.205-.996.997-.996.791 0 1.001.202 1.001.996l.007 2H17v-3.505h.5c1.611-.001 2.5-.887 2.5-2.495s-.889-2.5-2.5-2.5Zm0 3.492c-.558 0-1.254.004-1.254.004L15.5 14v3.5h-2V17c0-1.612-.889-2.5-2.5-2.5s-2.496.886-2.496 2.495v.5H6.5V8.5H10v-.75s.004-.697.004-1.254c0-.792.205-.996.996-.996s1 .207 1 1v1.25l.006.75H15.5v3.495l.75.005h1.25c.793 0 1 .207 1 1s-.207.994-1 .994v-.002Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
